import React from 'react'
import Screen from 'containers/Screen'
import PromocaoBox from 'components/PromocaoTJSP'

export default function PromocaoTJSPScreen () {
  return (
    <Screen title={''}>
      <PromocaoBox />
    </Screen>
  )
}
